"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** Вызывается при клике на лого или ссылку в баннере. Ссылки ведут в аппметрику и дальше редирект в сторы */
const appBannerClickExternal = ({ category }) => analytics_js_1.default.sendEvent(category, "click_hrmobile", "main_banner");
exports.default = appBannerClickExternal;
